"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeliveryTime = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = require("react");
var _contexts = require("../../sfra-api/contexts");
var _useMultiSite = require("../../hooks/use-multi-site");
const useDeliveryTime = () => {
  const [deliveryTime, setDeliveryTime] = (0, _react.useState)(null);
  const SFRAClient = (0, _contexts.useCommerceSFRAAPI)();
  const {
    locale
  } = (0, _useMultiSite.useMultiSite)();
  const getDeliveryTime = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(function* (shippingAddress) {
      // @ts-ignore
      const response = yield SFRAClient.DHLExpress.getArrivalTime({
        body: {
          address1: shippingAddress.address1,
          address2: shippingAddress.address2 || null,
          city: shippingAddress.city,
          postalCode: shippingAddress.postalCode,
          countryCode: shippingAddress.countryCode
        },
        query: {
          locale: locale.alias || locale.id
        }
      });
      if (response.success) {
        setDeliveryTime(response.result.deliveryTime);
      }
    });
    return function getDeliveryTime(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return [deliveryTime, getDeliveryTime];
};
exports.useDeliveryTime = useDeliveryTime;